import type { Dependencies } from '../../types/Dependencies'
import type { CollectionDoc } from '../../types/Doc'

export type AllDocumentChange =
  | {
      type: 'removed'
      documentId: string
    }
  | {
      type: 'upserted'
      document: CollectionDoc
    }

export function subscribeToAllDocumentChanges({
  records,
  onChange,
  onError,
}: {
  records: Dependencies['records']
  onChange: (change: AllDocumentChange) => void
  onError?: (error: unknown) => void
}) {
  return records.subscribe(onChange, onError)
}
